module.exports = __webpack_public_path__ + "img/michal_recommendation_v2.9e0aee12.png";